export default {
  DOWNLOAD_PARTICIPANT_ANSWERS: 'download participant answers',
  DOWNLOAD_LIFETIME_PARTICIPANT_ANSWERS: 'download lifetime participant answers',
  CAMPAIGN_LEADERBOARD_BREAKDOWN: 'campaign leaderboard breakdown',
};
